import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormErrorService {
  private handleFormErrors(errorData: unknown, form: FormGroup) {
    Object.keys(errorData).forEach((errorKey) => {
      if (Array.isArray(errorData[errorKey]) && errorKey !== 'nonFieldErrors') {
        const control = form.controls[errorKey];

        // Only set errors if the form control exists
        if (control) {
          control.setErrors({
            serverError: {
              message: errorData[errorKey].join(', '),
            },
          });

          // errors are displayed for touched fields
          control.markAsTouched();
        }
      } else if (errorKey === 'table') {
        // Custom error handler - used only with the table attachment components
        const fg = form.controls.offer as FormGroup;
        if (fg) {
          Object.entries(errorData[errorKey]).forEach(([index, err]) => {
            const indexControl = fg.controls[index] as FormGroup;
            if (indexControl) {
              this.handleFormErrors(err, indexControl);
            }
          });
        }
      }
    });
  }

  public onServerError(error: HttpErrorResponse, form: FormGroup) {
    const errorData = error.error;
    if (error.status === 400 && errorData) {
      this.handleFormErrors(errorData, form);
    }
  }
}
